import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const DeleteMeasurementModal = ({ measurement, isOpen, onClose, onConfirm }) => {
  if (!isOpen || !measurement) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div
        className="w-full max-w-md rounded-lg p-6 shadow-lg"
        style={{ backgroundColor: 'rgb(251, 249, 249)' }}
      >
        {/* Title */}
        <h1 className="mb-4 text-2xl font-bold text-[#e90606]">Delete: {measurement.label}</h1>

        {/* Warning message with icon */}
        <div className="mb-4 flex items-start gap-3 rounded border border-red-300 bg-red-50 p-4">
          <Icon
            name="icon-alert-small"
            className="h-6 w-6"
          />
          <div>
            <p className="mb-1 text-[#f03e3e] font-bold">
              Are you sure you want to delete this measurement?
            </p>
            <span className="text-black">
              This action is <strong>destructive</strong> and cannot be undone.
            </span>
          </div>
        </div>

        {/* Measurement details */}
        {/* <div className="mb-4 p-3 text-black">
          {measurement.displayText && (
            <p>
              <strong>Info:</strong> {measurement.displayText.join(', ')}
            </p>
          )}
        </div> */}

        {/* Buttons */}
        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 font-semibold text-[#4d5360] hover:text-[#997DBA]"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 font-semibold text-black hover:text-[#997DBA]"
            onClick={() => onConfirm(measurement.uid)}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

DeleteMeasurementModal.propTypes = {
  measurement: PropTypes.shape({
    uid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    displayText: PropTypes.arrayOf(PropTypes.string),
  }),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteMeasurementModal;
